import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { BtwLink, FullScreenPage } from '@marvelapp/ballpark-components';
const ContactCX = observer(function ContactCX() {
    return (_jsx(FullScreenPage.Container, { noFooter: true, children: _jsx(FullScreenPage.Message, { heading: "Contact us for more projects", description: _jsxs(_Fragment, { children: ["Please contact", ' ', _jsx(BtwLink, { underline: true, href: "mailto:experience@ballparkhq.com", children: "our team" }), ' ', "for access to more projects on your workspace."] }), descriptionMaxWidth: 320 }) }));
});
export { ContactCX };
